/**
 * Aggregate all property-wise section maps. Add new property files here.
 */
import { adminFormSections } from "./adminForm"
import { builderFloorSections } from "./builderFloor"
import { commercialOfficeSpaceSections } from "./commercialOfficeSpace"
import { flatOrApartmentSections } from "./flatOrApartment"
import { franchiseSections } from "./franchise"
import { hospitalitySections } from "./hospitality"
import { independentBuildingCommercialSections } from "./independentBuildingCommercial"
import { independentBuildingIndustrialSections } from "./independentBuildingIndustrial"
import { independentBuildingRetailSections } from "./independentBuildingRetail"
import { landSections } from "./land"
import { retailSpaceSections } from "./retailSpace"
import { warehouseSections } from "./warehouse"

export {
  adminFormSections,
  builderFloorSections,
  commercialOfficeSpaceSections,
  flatOrApartmentSections,
  franchiseSections,
  hospitalitySections,
  independentBuildingCommercialSections,
  independentBuildingIndustrialSections,
  independentBuildingRetailSections,
  landSections,
  retailSpaceSections,
  warehouseSections,
}

export function getSectionsFromPropertyFiles(): Record<string, import("../types").CategorySection[]> {
  return {
    ...landSections,
    ...franchiseSections,
    ...adminFormSections,
    ...builderFloorSections,
    ...commercialOfficeSpaceSections,
    ...flatOrApartmentSections,
    ...retailSpaceSections,
    ...warehouseSections,
    ...independentBuildingCommercialSections,
    ...independentBuildingIndustrialSections,
    ...independentBuildingRetailSections,
    ...hospitalitySections,
  }
}
